import { render } from "./Delegaciones.vue?vue&type=template&id=2fd76d39&scoped=true"
import script from "./Delegaciones.vue?vue&type=script&lang=js"
export * from "./Delegaciones.vue?vue&type=script&lang=js"

import "./Delegaciones.vue?vue&type=style&index=0&id=2fd76d39&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd76d39"]])

export default __exports__